import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { Logger } from "./utils/logger";

export function getFirebaseConfig() {
  const config = {
    apiKey: process.env.FIREBASE_API_KEY!,
    authDomain: process.env.FIREBASE_AUTH_DOMAIN!,
    projectId: process.env.FIREBASE_PROJECT_ID!,
    storageBucket: process.env.FIREBASE_STORAGE_BUCKET!,
    messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID!,
    appId: process.env.FIREBASE_APP_ID!,
    measurementId: process.env.FIREBASE_MEASUREMENT_ID || undefined,
  };

  // 🧪 Debug-Log nur im Development
  Logger.debug("🔥 Firebase-Konfiguration geladen:", config);

  // ✅ Validierung (nur lokal/Tests)
  if (process.env.NODE_ENV !== "production") {
    for (const [key, value] of Object.entries(config)) {
      if (!value && key !== "measurementId") {
        Logger.warn(`⚠️ Firebase-Konfiguration fehlt für: ${key}`);
      }
    }
  }

  return config;
}

export const app = initializeApp(getFirebaseConfig());
export const db = getFirestore(app);
export const auth = getAuth(app);
